import { createContext, ReactNode, useContext } from 'react';
import { useAddAssetState } from '../hooks/asset/useAddAssetState';
import type { ImageTypeKey } from '../hooks/asset/useAddAssetState';
import { UPLOAD_TYPES } from '../hooks/asset/useAddAssetState';

export type { ImageTypeKey };
export { UPLOAD_TYPES };

export type AddAssetContextType = ReturnType<typeof useAddAssetState>;

const AddAssetContext = createContext<AddAssetContextType | null>(null);

interface AddAssetProviderProps {
  children: ReactNode;
  onClose: () => void;
}

export const AddAssetProvider: React.FC<AddAssetProviderProps> = ({ children, onClose }) => {
  const addAssetState = useAddAssetState(onClose);

  return (
    <AddAssetContext.Provider value={addAssetState}>
      {children}
    </AddAssetContext.Provider>
  );
};

export const useAddAsset = (): AddAssetContextType => {
  const context = useContext(AddAssetContext);
  if (!context) {
    throw new Error('useAddAsset must be used within an AddAssetProvider');
  }
  return context;
};
